import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { updateParentId } from "Administrator/modules/AdministratorModule";

import OverallSetup from "Administrator/commonComponents/GradingSetup/routes/OverallSetup";
import OverallGradeSetup from "Administrator/commonComponents/GradingSetup/routes/OverallGradeSetup";
import AssessmentCategorySetup from "Administrator/commonComponents/GradingSetup/routes/AssessmentCategorySetup";
import CumulativeScoreSetup from "Administrator/commonComponents/GradingSetup/routes/CumulativeScoreSetup";
import GradeBoundarySetup from "Administrator/commonComponents/GradingSetup/routes/GradeBoundarySetup";
import LocalGradesSetup from "Administrator/commonComponents/GradingSetup/routes/LocalGradeSetup";
import AggregateSetup from "Administrator/commonComponents/GradingSetup/routes/AggregateSetup";
import CreditsSetup from "Administrator/commonComponents/GpaAndCredits/routes/CreditsSetup";
import GpaSetup from "Administrator/commonComponents/GpaAndCredits/routes/GpaSetup";
import CreateEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria/routes/CreateEvaluationCriteria";
import MapEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria/routes/MapEvaluationCriteria";
import EvaluationCriteriaSettings from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria/routes/EvaluationCriteriaSettings";
import ProjectProgressIndicators from "Administrator/commonComponents/ProjectProgressIndicators";
import AssessmentTypeSettings from "Administrator/commonComponents/GradingSetup/routes/AssessmentTypes";

export default store => ({
  path: "grading-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  onEnter(nextState, replace) {
    store.dispatch(updateParentId("GRADING_SETUP"));
  },
  childRoutes: [
    OverallSetup(store),
    AssessmentCategorySetup(store),
    CumulativeScoreSetup(store),
    GradeBoundarySetup(store),
    OverallGradeSetup(store),
    AggregateSetup(store),
    CreditsSetup(store),
    GpaSetup(store),
    CreateEvaluationCriteria(store),
    MapEvaluationCriteria(store),
    EvaluationCriteriaSettings(store),
    ProjectProgressIndicators(store),
    AssessmentTypeSettings(store),
    LocalGradesSetup(store),
  ],
});
